import { useState } from 'react';

export interface FaqItem {
  q: string;
  a: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpen?: number;
  tone?: 'light' | 'plain';
}

export default function FaqAccordion({ items, defaultOpen = 0, tone = 'light' }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number>(defaultOpen);

  return (
    <div className="space-y-3">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={item.q}
            className={`rounded-lg border transition-colors ${
              tone === 'light'
                ? isOpen
                  ? 'border-primary-300 bg-background-50'
                  : 'border-background-200 bg-background-50'
                : isOpen
                  ? 'border-primary-300 bg-background-100'
                  : 'border-background-200 bg-background-100'
            }`}
          >
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 px-4 md:px-6 py-4 md:py-5 text-left"
              >
                <span className="flex items-start gap-3">
                  <span className="mt-0.5 text-xs font-heading text-primary-500">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="text-sm md:text-base font-medium text-foreground-900">{item.q}</span>
                </span>
                <span
                  className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md transition-colors ${
                    isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 md:px-6 pb-5 md:pl-[3.25rem]">
                <p className="text-sm text-foreground-600 leading-7">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}